import { Button, Flex, Text } from '@radix-ui/themes';
import { CheckedContext } from 'contexts/layout/checked.context';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext } from 'react';
import useMiscStore from 'stores/use-misc-store';

const CustomCheckboxIcon = (props: { state: boolean | 'indeterminate' }) => {
  const isDarkMode = useMiscStore((s) => s.isDarkMode);

  switch (props.state) {
    case true:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_5101_799)">
            <g filter="url(#filter0_ii_5101_799)">
              <path
                d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3Z"
                fill="#3E63DD"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.9482 3.59209C12.2563 3.79358 12.3428 4.20674 12.1413 4.5149L7.60798 11.4483C7.50115 11.6117 7.32806 11.7199 7.13441 11.7447C6.94076 11.7694 6.74601 11.708 6.60155 11.5767L3.66822 8.91003C3.39578 8.66236 3.37571 8.24073 3.62337 7.96829C3.87104 7.69585 4.29268 7.67577 4.56511 7.92345L6.91991 10.0642L11.0254 3.78524C11.2269 3.47708 11.64 3.3906 11.9482 3.59209Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_ii_5101_799"
              x="0"
              y="0"
              width="16"
              height="17.5"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1.5" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.847059 0 0 0 0 0.956863 0 0 0 0 0.964706 0 0 0 0.0352941 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_5101_799"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1.5" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_5101_799"
                result="effect2_innerShadow_5101_799"
              />
            </filter>
            <clipPath id="clip0_5101_799">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case 'indeterminate':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_5109_844)">
            <g filter="url(#filter0_ii_5109_844)">
              <rect
                width="16"
                height="16"
                rx="3.42857"
                fill="#3354FA"
                fillOpacity="0.0901961"
              />
            </g>
            <rect
              x="0.571429"
              y="0.571429"
              width="14.8571"
              height="14.8571"
              rx="2.85714"
              stroke="#5A7FFF"
              strokeOpacity="0.564706"
              strokeWidth="1.14286"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.33334 8C5.33334 7.70545 5.57213 7.46667 5.86668 7.46667H10.1333C10.4279 7.46667 10.6667 7.70545 10.6667 8C10.6667 8.29455 10.4279 8.53333 10.1333 8.53333H5.86668C5.57213 8.53333 5.33334 8.29455 5.33334 8Z"
              fill="#9EB1FF"
            />
          </g>
          <defs>
            <filter
              id="filter0_ii_5109_844"
              x="0"
              y="0"
              width="16"
              height="17.7143"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1.71429" />
              <feGaussianBlur stdDeviation="1.14286" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.847059 0 0 0 0 0.956863 0 0 0 0 0.964706 0 0 0 0.0352941 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_5109_844"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1.71429" />
              <feGaussianBlur stdDeviation="1.14286" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_5109_844"
                result="effect2_innerShadow_5109_844"
              />
            </filter>
            <clipPath id="clip0_5109_844">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case false:
    default:
      if (isDarkMode) {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_5101_798)">
              <g filter="url(#filter0_ii_5101_798)">
                <path
                  d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3Z"
                  fill="black"
                  fillOpacity="0.25"
                />
              </g>
              <path
                d="M3 0.5H13C14.3807 0.5 15.5 1.61929 15.5 3V13C15.5 14.3807 14.3807 15.5 13 15.5H3C1.61929 15.5 0.5 14.3807 0.5 13V3C0.5 1.61929 1.61929 0.5 3 0.5Z"
                stroke="#D9EDFF"
                strokeOpacity="0.25098"
              />
            </g>
            <defs>
              <filter
                id="filter0_ii_5101_798"
                x="0"
                y="0"
                width="16"
                height="17.5"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="1.5" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.847059 0 0 0 0 0.956863 0 0 0 0 0.964706 0 0 0 0.0352941 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_5101_798"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="1.5" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_5101_798"
                  result="effect2_innerShadow_5101_798"
                />
              </filter>
              <clipPath id="clip0_5101_798">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }

      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_ii_5104_832)">
            <path
              d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3Z"
              fill="white"
              fillOpacity="0.9"
            />
            <path
              d="M3 0.5H13C14.3807 0.5 15.5 1.61929 15.5 3V13C15.5 14.3807 14.3807 15.5 13 15.5H3C1.61929 15.5 0.5 14.3807 0.5 13V3C0.5 1.61929 1.61929 0.5 3 0.5Z"
              stroke="#00062E"
              strokeOpacity="0.196078"
            />
          </g>
          <defs>
            <filter
              id="filter0_ii_5104_832"
              x="0"
              y="0"
              width="16"
              height="17.5"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1.5" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.333333 0 0 0 0.0235294 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_5104_832"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1.5" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_5104_832"
                result="effect2_innerShadow_5104_832"
              />
            </filter>
          </defs>
        </svg>
      );
  }
};

export const CheckAllButton = (props: {
  ids: string[];
  className?: string;
}) => {
  const { tally, setChecked, resetChecked } = useContext(CheckedContext);

  // todo: maybe the "select all" text should be "select none" if the check state is true (i.e. everything is already selected)
  // ? reason: clicking the button in this state would deselect everything, "select none" is more accurate of what will happen

  return (
    <Button
      variant={RADIX.BUTTON.VARIANT.SECONDARY}
      size={RADIX.BUTTON.SIZE.TABLE}
      color={RADIX.COLOR.NEUTRAL}
      onClick={() => {
        switch (tally.checkAllState) {
          case true: {
            // deselect everything
            resetChecked();
            break;
          }

          case false:
          case 'indeterminate':
          default: {
            setChecked(props.ids, true);
            break;
          }
        }
      }}
      className={props.className}
    >
      <Flex align="center" gap="1">
        <CustomCheckboxIcon state={tally.checkAllState} />
        <Text color={RADIX.COLOR.NEUTRAL}>{t('common.select-all')}</Text>
      </Flex>
    </Button>
  );
};
